import {ChangeDetectionStrategy, Component, inject, OnInit, OnDestroy} from '@angular/core';
import {AsyncPipe} from '@angular/common';
import {Store} from '@ngrx/store';

import {TitleService} from '../../core/page/title.service';
import {GetLensesAction} from '../../core/store/lenses/lenses.action';
import {LensesHeaderComponent} from '../lenses-header/lenses-header.component';
import {LensesTableComponent} from '../lenses-table/lenses-table.component';
import {selectLenses} from '../../core/store/lenses/lenses.selector';
import {OphLoadingModule} from '../../shared/design/oph-loading/oph-loading.module';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'lenses-main',
  standalone: true,
  imports: [LensesHeaderComponent, LensesTableComponent, AsyncPipe, OphLoadingModule],
  templateUrl: './lenses-main.component.html',
  styleUrl: './lenses-main.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LensesMainComponent implements OnInit, OnDestroy {
  private store$ = inject(Store);
  private titleService = inject(TitleService);

  allLenses$ = this.store$.select(selectLenses);
  searchValue$ = new BehaviorSubject<string>('');

  ngOnInit(): void {
    this.titleService.setPageTitle('Lenses');
    this.store$.dispatch(new GetLensesAction({}));
  }

  ngOnDestroy(): void {
    this.searchValue$.complete();
  }
}
